import { storage } from './storage.js';

/* Términos de uso y privacidad: la primera pantalla de todas (web, con o sin cuenta, y apps sin servidor). Sin aceptarlos no
   se entra. Aquí va la decisión, pura y probada; la pantalla está en pages/terms.js. */

/** Versión incorporada en la app (web sin cuenta y apps sin servidor). Cuando cambien los textos legales hay que cambiar esta
    fecha y, en el servidor, TERMS_VERSION: a todo el mundo se le vuelve a pedir que acepte. */
export const TERMS_VERSION = '2026-10-07';
const KEY = 'termsAccepted';

/** Versión vigente: la que dicta el servidor si tiene términos configurados; si no, la incorporada. */
export function currentTermsVersion(account) {
    const v = account && account.terms && account.terms.version;
    return v ? String(v) : TERMS_VERSION;
}

/** Lo aceptado en este aparato: { version, at } o null. */
export function termsRecord() {
    const r = storage.get(KEY);
    return r && r.version ? r : null;
}

export function saveTermsRecord(version, extra = {}) {
    const rec = Object.assign({ version: String(version), at: Date.now() }, extra);
    storage.set(KEY, rec);
    return rec;
}

export function clearTermsRecord() {
    storage.remove(KEY);
}

/**
 * ¿Hay que enseñar la pantalla de términos? `record` es lo aceptado en este aparato; `account` lleva `signedIn`, `online`,
 * `terms` (los del servidor, o null) y `user.terms` ({ accepted }) cuando hay sesión.
 * - Con cuenta y un servidor que exige términos, manda el servidor: si dice que no están aceptados, pantalla. Excepción: sin
 *   conexión y con esa misma versión ya aceptada en este aparato, se deja entrar (el servidor lo volverá a pedir al conectar).
 * - En los demás casos, pantalla si en este aparato no se ha aceptado la versión vigente.
 */
export function needsTermsGate({ record = null, account = null } = {}) {
    const version = currentTermsVersion(account);
    const localOk = !!(record && String(record.version) === version);
    const serverTerms = account && account.signedIn && account.user && account.user.terms;
    if (serverTerms) {
        if (serverTerms.accepted) return false;
        return !(localOk && account.online === false);
    }
    return !localOk;
}
